import { render } from "./DeliveryProcess.vue?vue&type=template&id=0e20df64&scoped=true"
import script from "./DeliveryProcess.vue?vue&type=script&lang=js"
export * from "./DeliveryProcess.vue?vue&type=script&lang=js"

import "./DeliveryProcess.vue?vue&type=style&index=0&id=0e20df64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e20df64"]])

export default __exports__